import { DataTable } from "../DataTable";
import {
  CheckedInCell,
  CopyLinkButton,
  NameCell,
  StatusBadge,
  TakeOutButton,
  getAppStatus,
} from "./ticketParts";

/**
 * Who it is, where the ticket is in the app, and whether they came. A row has
 * at most one action, and only when there is something to do: a ticket not in
 * the app yet gets its link, a locked out guest gets taken out. Everything
 * else is one click away, on the ticket.
 */
function StatusList({ records, onOpen, tableProps }) {
  return (
    <DataTable
      {...tableProps}
      records={records}
      onRowClick={({ record }) => onOpen(record.id)}
      columns={[
        {
          accessor: "name",
          title: "Name",
          render: (row) => <NameCell ticket={row} />,
        },
        {
          accessor: "app",
          title: "App",
          width: 120,
          render: (row) => <StatusBadge ticket={row} />,
        },
        {
          accessor: "checkedInAt",
          title: "Checked in",
          width: 130,
          render: (row) => <CheckedInCell ticket={row} />,
        },
        {
          accessor: "next",
          title: "",
          width: 150,
          textAlign: "right",
          render: (row) => <NextAction ticket={row} />,
        },
      ]}
    />
  );
}

function NextAction({ ticket }) {
  const status = getAppStatus(ticket);
  if (status === "notAdded") return <CopyLinkButton ticket={ticket} />;
  if (status === "lockedOut") return <TakeOutButton ticket={ticket} />;
  return null;
}

export default StatusList;
